import { useDispatch, useSelector } from 'react-redux'
import classes from './HistoryHeaderCell.module.css'
import { useState } from 'react'
import { historyActions } from '../../store/history'

export default function HistoryHeaderCell({item}) {
    const dispatch = useDispatch()
    const [sortDirection, setSortDirection] = useState(true)

    const orderFilters = useSelector(state => state.history.orderFilters)
    const loading = useSelector(state => state.history.loading)

    async function sortTableHandler() {
        setSortDirection(prev => prev = !prev)
        dispatch(historyActions.setOrderFilters({
            id: item.id,
            label: item.label,
            isDesc: sortDirection
        }))
    }

    return <div className={classes.header_cell} > 
        <div>
            {item.name} 
        </div>
        {item.sortable ? <button onClick={sortTableHandler} disabled={loading} className={`${classes.button} ${(orderFilters && orderFilters.id == item.group+item.label )? classes.active : ''}`}>
            {loading && <span className={`loader`}></span>}
            {!loading && <>
                {(orderFilters && orderFilters.id == item.group+item.label) ?  <>
                        {orderFilters.isDesc && <i className='ti ti-sort-descending'></i>}
                        {!orderFilters.isDesc && <i className='ti ti-sort-ascending'></i>}
                    </>
                    : <i className='ti ti-sort-descending'></i>}
            </>}
        </button> : ''}
    </div>
}